<template>
  <div style="margin-top: 40%">
    <div class="title">
      <h3 style="font-size: 30px">欢迎登录</h3>
    </div>
    <Form @submit="onSubmit">
      <CellGroup inset>
        <Field
            v-model="form.userName"
            name="用户名"
            label="用户名"
            placeholder="请输入用户名"
            :rules="[{ required: true, message: '请填写用户名' }]"
        />
        <Field
            v-model="form.password"
            type="password"
            name="密码"
            label="密码"
            placeholder="请输入密码"
            :rules="[{ required: true, message: '请填写密码' }]"
        />


      </CellGroup>
      <div style="margin: 16px;text-align: center">
        <Button plain type="primary" native-type="submit">
          登&nbsp;&nbsp;&nbsp;&nbsp;录
        </Button>
      </div>
    </Form>
  </div>
</template>


<script setup>
import {Form, Field, CellGroup, Tag, Button, Toast} from 'vant';
import {reactive, ref} from "vue";

import request from "../utils/request";
import {useStore} from "vuex";
import {router} from "../router";

let store = useStore()

let form = reactive({
  userName: '',
  password: '',
})

const onSubmit = (values) => {


  const toast1 = Toast.loading({
    message: '登录中...',
    forbidClick: true,
  });
  request.post("/user/login", form).then(res => {
    if (res.code === '0') {
      toast1.clear()
      Toast.success('登录成功');
      store.commit('SetLoginUser',res.data)
      console.log(res.data)
      // 登录成功的时候更新当前路由
      router.push("/home")  //登录成功之后进行页面的跳转，跳转到主页

    } else {
      toast1.clear()
      Toast.fail(res.msg);
    }
  })
  console.log(values)
};
</script>

<style scoped>
.title {
  width: 100%;
  text-align: center;
  color: #3fabff;
}

</style>
